import { compose, withProps } from 'recompose';
import withInvoiceDeliveryTypes from '../../../entities/InvoiceDeliveryType/withInvoiceDeliveryTypes';
import RichSelect from '../RichSelect/RichSelect';
import { withTranslation } from 'react-i18next';

export default compose(
  withTranslation(),
  withProps({
    placeHolder: 'Välj leveranssätt',
    filterOption: null,
  }),
  withInvoiceDeliveryTypes(true),
  withProps(({ invoiceDeliveryTypes }) => ({
    options: invoiceDeliveryTypes ? invoiceDeliveryTypes
      .map(({ type, name }) => ({ value: type, label: name })) : [],
  })),
)(RichSelect);
